<section class="hero-wrap hero-wrap-2" style="background-image: url('../../assets/images/bg_4.jpg');">
    <div class="overlay"></div>
    <div class="container">
        <div class="row no-gutters slider-text align-items-center justify-content-center">

        </div>
    </div>
</section>


<section class="ftco-section bg-light">
    <div class="container">
        <div class="row no-gutters justify-content-center">
            <div class="col-md-12">
                <div class="wrapper">
                    <div class="row d-flex justify-content-center g-0">
                        <div class="col-lg-6">
                            <div class="contact-wrap w-100  wrap-content">
                                <!-- <h3>
                                    Profile View
                                </h3> -->
                                <form id="contactForm"
                                    [formGroup]="profileviewForm"
                                    name="profileForm" class="contactForm">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>Full Name</label>
                                                <input type="text"
                                                    class="form-control"
                                                    name="f_name" id="f_name"
                                                    placeholder="Full Name"
                                                    formControlName="name"
                                                    [class.is-invalid]="profileviewForm.get('name')!.invalid && this.submit==true">
                                                <div class="invalid-feedback">
                                                    Full Name is required.
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="col-md-12">
                                            <div class="form-group">
                                                <label>Last Name</label>
                                                <input type="text" class="form-control" name="l_name" id="l_name"
                                                    placeholder="Last name"formControlName="last_name"
                                                    [class.is-invalid]="profileviewForm.get('last_name')!.invalid && this.submit==true">
                                                <div class="invalid-feedback">
                                                    Last Name is required.
                                                </div>
                                            </div>
                                        </div> -->
                                        <!-- profileview.component.html -->
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>Email</label>
                                                <input type="email"
                                                    class="form-control"
                                                    name="email" id="email"
                                                    placeholder="Email"
                                                    formControlName="email"
                                                    [class.is-invalid]="profileviewForm.get('email')!.invalid && this.submit==true">
                                                <div class="invalid-feedback">
                                                    Email is required.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>Phone Number</label>
                                                <input type="text"
                                                    class="form-control"
                                                    name="phone" id="phone"
                                                    placeholder="Phone number"
                                                    formControlName="phone"
                                                    [class.is-invalid]="profileviewForm.get('phone')!.invalid && this.submit==true">
                                                <div class="invalid-feedback">
                                                    Phone Number is required.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <input type="checkbox"
                                                    formControlName="is_whatsapp"
                                                    (change)="toggleWhatsApp()">
                                                Same as Phone or ask for another
                                                phone number
                                            </div>
                                        </div>
                                        <div class="col-md-12"
                                            *ngIf="showWhatsApp">
                                            <div class="form-group">
                                                <label>WhatsApp Number</label>
                                                <input type="text"
                                                    class="form-control"
                                                    name="whatsapp"
                                                    id="whatsapp"
                                                    placeholder="WhatsApp number"
                                                    formControlName="whatsapp_no"
                                                    [class.is-invalid]="profileviewForm.get('whatsapp_no')!.invalid && this.submit==true">
                                                <div class="invalid-feedback">
                                                    WhatsApp Number is required.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <button type="button"
                                                    (click)="onSubmit()"
                                                    id="submit"
                                                    class="btn btn-primary">Submit</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <div class="w-100 p-4 mt-3" style="padding: 0px !important;">
                                    <div class="text-center">
                                        <a class="text-secondary text-decoration-underline" href="/delete-account">Delete account</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
